import type { Configuration } from "../config";
import { defaults } from "./defaults";

const configuration: Configuration = {
  ...defaults,
  emailjs: {
    userId: "user_fEge3rEtuLIilxtruCGSN",
    serviceId: "post.alpinewhite.com",
    templateId: "contact_form_br",
  },
  elfsight: { instagram: "elfsight-app-33796328-445a-4686-b5c6-cbc5d86f0448" },
  shop: {
    instance: "BR",
    sections: {
      shop: true,
      treatments: false,
    },
    countries: ["BR"],
    url: "https://br.alpinewhite.com",
    lang: { main: "pt", enabled: ["pt"] },
    stamped: false,
    newsletter: true,
    partners: [
      "BR_Discover",
      "BR_DrogariaIguatemi",
      "BR_Nuspace",
      "BR_Panvel",
      "BR_Glam",
      "BR_SaoJoao",
      "BR_DrogariaSaoPaulo",
      "BR_MedFarma",
      "BR_Raia",
      "BR_Stylofarma",
      "BR_Trajano",
      "BR_Drogaven",
      "BR_FazFarma",
      "BR_ZonaSul",
      "BR_Pacheco",
      "BR_Venancio",
      "BR_Nissei",
      "BR_Bistek",
      "BR_Araujo",
    ],
    scripts: {
      gtm: "GTM-P3K8685",
      facebook: "709898453288442",
      tiktok: "D4E6JNJC77U1KRQJG120",
      pinterest: "2613981124848",
    },
    shopifyClient: {
      domain: "shopbr.alpinewhite.com",
      accessToken: "ccd9ca30b86ae7ce08cc59c853e8e4a3",
      shopId: "gid://shopify/Shop/50128912570",
      storefrontId: "1000094206",
    },
    meta: {
      pt: {
        title: "Alpine White | Fitas Clareadoras Dentais | Carvão Clareador | Clareamento",
        description:
          "Descubra a gama de produtos Alpine White. Limpeza, cuidado e clareamento caseiro para um hálito fresco, gengivas saudáveis e dentes brancos.",
        keywords: [
          "Fitas Clareadoras Dentais",
          "Kit Clareador Dental",
          "Clareamento",
          "Limpeza",
          "Cuidado",
          "Espuma Clareadora Dental",
          "Carvão Clareador Dental Em Po",
        ],
      },
      en: {
        title: "Alpine White | Teeth Whitening Strips | Whitestrips | Bleaching",
        description:
          "Give yourself a radiant smile with white teeth. Alpine White provides a complete kit for cleaning, bleaching and care. Discover our Whitening Strips.",
        keywords: [
          "Whitening Strips",
          "Whitestrips",
          "Bleaching",
          "Homebleaching",
          "Whitening Kit",
          "Dental Care",
          "White Teeth",
          "Charcoal Powder",
          "Whitening Foam",
        ],
      },
    },
  },
};

export { configuration };
